if (!customElements.get('trending-product-carousel')) {
  customElements.define('trending-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tp-track');
      if (!this.track) return;
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      this.move = (direction) => {
        const card = this.track.querySelector('.tp-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', this.update, options);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
      if (this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => {
          if (document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
          const bounds = this.getBoundingClientRect();
          if (bounds.bottom < 0 || bounds.top > innerHeight) return;
          if (this.next.disabled) this.track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.move(1);
        }, Number(this.dataset.interval) || 5000);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      clearInterval(this.timer);
    }
  });
}
